import React, { useRef, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import withSizes from "react-sizes";
import BlogContent from "../BlogContent/BlogContent";
import Button from "../../atomic/Button/Button";
import UrlEmbed from "../../atomic/UrlEmbed/UrlEmbed";
import Tags from "../../atomic/Tags/Tags";

const Root = styled.div`
  width: 100%;
  max-width: 1270px;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.color5};
`;

const EditLayout = styled.div`
  width: 100%;
  max-width: 1270px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 20px;
  padding-bottom: 0px;
  background-color: white;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 55%;
  width: 55%;
`;

const SimpleDiv = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

const SimpleLabel = styled.label`
  color: ${props => props.theme.grayTextColor};
  font-weight: 600;
  padding-right: 10px;
  flex-grow: 1;
`;

const predefinedTags = [
  "Activities",
  "Deal",
  "Outdoor",
  "Application",
  "Education",
  "Coding"
];

const Content = styled.div`
  display: flex;
  width: 100%;
`;

const Buttons = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 50;
  padding: 20px;
  background-color: ${props => props.theme.color1};
`;

const Menu = styled.ul`
  display: flex;
  height: 50px;
  align-items: center;
  padding-left: 20px;
  background-color: ${props => props.theme.color1};
  li {
    height: 100%;
  }
`;

const MenuButton = styled.button`
  height: 100%;
  padding: 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  background-color: ${props =>
    !props.selected ? props.theme.color1 : props.theme.color5};
  color: ${props => (props.selected ? props.theme.color1 : props.theme.color5)};
`;

const AdditionalInfo = styled.div`
  padding-top: 30px;
  max-width: 410px;
  width: 100%;
  background-color: #fff;
  border-left: 1px solid #eee;
  h3 {
    padding-left: 10px;
    font-weight: 600;
  }
`;
const Blog = styled.div`
  @media (min-width: 801px) {
    padding-right: 30px;
  }
  flex-grow: 1;
  background-color: ${props => props.theme.backgroundColor};
`;

export default withSizes(({ width }) => {
  return {
    width
  };
})(
  withTheme(({ onSave, uploadFolder, blog, onCancel, width }) => {
    const [image, setImage] = useState(blog.image || "");
    const [tags, setTags] = useState(blog.tags || []);
    const [title, setTitle] = useState(blog.title || "");
    const [url, setUrl] = useState(blog.url || "");
    const [valid, setValid] = useState(blog.title && blog.title.trim());
    const [imageDimensions, setImageDimensions] = useState(
      blog.imageDimensions || {}
    );
    const [content, setContent] = useState(blog.content || "");
    const [tab, setTab] = useState("content");
    const [media, setMedia] = useState(blog.media || []);
    const toBlog = () => {
      const newBlog = {
        image,
        tags,
        title,
        content,
        media,
        imageDimensions,
        id: blog.id,
        url
      };
      const updated = { ...blog, ...newBlog };
      return updated;
    };
    const validate = () => {
      setValid(title && title.trim());
      return title && title.trim();
    };
    console.log("THE BLOG", blog);
    return (
      <Root>
        {width < 800 && (
          <Menu>
            <li>
              <MenuButton
                onClick={() => setTab("content")}
                selected={tab === "content"}
              >
                Content
              </MenuButton>
            </li>
            <li>
              <MenuButton
                onClick={() => setTab("details")}
                selected={tab === "details"}
              >
                Additional Information
              </MenuButton>
            </li>
          </Menu>
        )}
        <Content>
          {(width >= 800 || tab === "content") && (
            <Blog>
              <BlogContent
                uploadFolder={uploadFolder}
                content={{ instructions: content, title, media }}
                onChange={content => {
                  setTitle(content.title);
                  setContent(content.instructions);
                  setMedia(content.media);
                  const mediaImage = (content.media || []).filter(
                    m => m.type === "image"
                  )[0];
                  if (mediaImage) {
                    setImage(mediaImage.url);
                    setImageDimensions({
                      height: mediaImage.height,
                      width: mediaImage.width
                    });
                  }
                }}
              />
            </Blog>
          )}
          {(width >= 800 || tab === "details") && (
            <AdditionalInfo>
              <h3>Additional Information</h3>
              <hr />
              <EditLayout>
                <Right>
                  <SimpleDiv>
                    <SimpleLabel for="FromURL">Link</SimpleLabel>
                    <UrlEmbed
                      noEmbed
                      id="FromURL"
                      url={url}
                      onChange={u => setUrl(u)}
                    />
                  </SimpleDiv>
                  <SimpleDiv>
                    <SimpleLabel for="ActivityTags">Tags</SimpleLabel>
                    <Tags
                      tags={tags}
                      id="ActivityTags"
                      onChange={ts => setTags(ts)}
                      suggestions={predefinedTags.map(t => ({
                        name: t,
                        value: t
                      }))}
                    />
                  </SimpleDiv>
                </Right>
                <Right></Right>
              </EditLayout>
            </AdditionalInfo>
          )}
        </Content>
        <Buttons>
          <Button inverted onClick={onCancel}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (!valid) {
                const v = validate();
                if (v) {
                  onSave(toBlog());
                }
              } else {
                onSave(toBlog());
              }
            }}
          >
            Save
          </Button>
        </Buttons>
      </Root>
    );
  })
);
